module.exports = __webpack_public_path__ + "img/ic_truck-delivery.0ab9a45e.svg";